import React, {Component} from 'react';
import DataTable from 'react-data-table-component';
import DynamicModal from '../../../../../components/DynamicModal/DynamicModal';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import TableSearchFields from '../../../../../components/TableSearchFields/TableSearchFields';
import {http_call, func_privileges} from '../../../../../libs/utils';
import './css/style.css';
import PubSub from 'pubsub-js';
import {confirm} from 'react-bootstrap-confirmation';





export default class DepartmentManagement extends Component {
    constructor(props) {
        let func = {"add": 117, 'del': 118, 'edit': 119, 'get': 116}
        func = func_privileges(func)
        super(props);
        this.state = {
            "func": func,
            name: "单位部门管理",
            "modal_show": false,
            "modal_title": "",
            "modal_rules": [],
            "modal_submit_title": "",
            "modal_submit_callback": "",
            column: [
                {
                    "name": "ID",
                    "selector": row => row.id,
                },
                {
                    "name": "部门名称",
                    "selector": row => row.bmmc
                },
                {
                    "name": "部门简介",
                    "selector": row => row.bmjj,
                    maxWidth: '600px',
                    whiteSpace: 'break-spaces',
                },
                {
                    "name": "操作",
                    "width": "100px",
                    "selector": row => {
                        return <div style={{"minWidth": "150px"}}>
                            { this.state.func.del ?<FontAwesomeIcon title='删除' icon="fa fa-trash"
                                             size='xl'
                                             style={{
                                                 'color': 'red',
                                                 "cursor": "pointer"
                                             }} onClick={e => {
                                this.del_dwbm(row.id)
                            }}/>:null}
                            { this.state.func.edit ?<FontAwesomeIcon title='编辑' icon="fa fa-pen-to-square"
                                             size='xl'
                                             style={{
                                                 'color': '#d38269',
                                                 "cursor": "pointer",
                                                 "marginLeft": '5px'
                                             }} onClick={e => {
                                this.edit_dwbm(e, row.id)
                            }}/>:null}
                        </div>
                    }
                },

            ],
            "search_rule": [
                {
                    "label_name": "部门名称",
                    "type": "text",
                    "id": "search_bmmc",
                    "value": "",
                    "must": false,
                    "nullable": false,
                },
            ],
            selectRows: {},
        }
    }

    componentDidMount() {
        this.get_all_dwbm()
    }

    add_dwbm = (e) => {
        this.setState({
            "modal_show": true,
            "modal_title": "新增单位部门",
            "modal_rules": [
                {
                    "label_name": "部门名称",
                    "type": "text",
                    "id": "bmmc",
                    "value": "",
                    "must": true,
                    "nullable": false,
                },
                {
                    "label_name": "部门简介",
                    "type": "textarea",
                    "id": "bmjj",
                    "value": "",
                    "must": true,
                    "nullable": true,
                },
            ],
            "modal_submit_title": "提交",
            "modal_submit_callback": (e, data) => {
                http_call('/jzzwdt/department', 'POST', data).then(res => {
                    let alert_info;
                    if (res.RTN_CODE === '01') {
                        alert_info = {
                            "title": "提示",
                            "content": res.RTN_MSG,
                            "type": "success",
                            "position": "top-right",
                            "dismiss": 1000,
                        }
                        this.setState({"modal_show": false})
                        this.get_all_dwbm()
                    } else {
                        alert_info = {
                            "title": "提示",
                            "content": res.RTN_MSG,
                            "type": "error",
                            "position": "top-right",
                            "dismiss": 1000,
                        }
                    }
                    PubSub.publish('AlertNotify', alert_info);
                })
            },
        });
    }

    edit_dwbm= (e, id) => {
        PubSub.publish('Loding', true);
        http_call('/jzzwdt/department', 'GET', {'id': id}).then(res => {
            PubSub.publish('Loding');
            this.setState({
                "modal_show": true,
                "modal_title": "修改单位部门",
                "modal_rules": [
                    {
                        "label_name": "部门id",
                        "type": "hidden",
                        "id": "id",
                        "value": id,
                        "must": true,
                        "nullable": false,
                    },
                    {
                        "label_name": "部门名称",
                        "type": "text",
                        "id": "bmmc",
                        "value": res.DATA[0].bmmc,
                        "must": true,
                        "nullable": false,
                    },
                    {
                        "label_name": "部门简介",
                        "type": "textarea",
                        "id": "bmjj",
                        "value": res.DATA[0].bmjj,
                        "must": true,
                        "nullable": true,
                    },
                ],
                "modal_submit_title": "提交",
                "modal_submit_callback": (e, data) => {
                    console.log(data);
                    http_call('/jzzwdt/department/edit', 'POST', data).then(res => {
                        let alert_info;
                        if (res.RTN_CODE === '01') {
                            alert_info = {
                                "title": "提示",
                                "content": res.RTN_MSG,
                                "type": "success",
                                "position": "top-right",
                                "dismiss": 1000,
                            }
                            this.setState({"modal_show": false})
                            this.get_all_dwbm()
                        } else {
                            alert_info = {
                                "title": "提示",
                                "content": res.RTN_MSG,
                                "type": "error",
                                "position": "top-right",
                                "dismiss": 1000,
                            }
                        }
                        PubSub.publish('AlertNotify', alert_info);
                    })
                },
            });
        })
    }

    del_dwbm= async (id) => {
        const result = await confirm(<h2 className='text-center text-danger'>确认删除?</h2>,
            {
                "title": <div><h4 className='text-center text-warning'>警告</h4></div>,
                "okText": "确认",
                okButtonStyle: 'warning',
                "cancelText": "取消"
            });
        if (result) {
            http_call('/jzzwdt/department/delete', 'POST', {'id': id}).then(res => {
                let alert_info;
                if (res.RTN_CODE === '01') {
                    alert_info = {
                        "title": "提示",
                        "content": res.RTN_MSG,
                        "type": "success",
                        "position": "top-right",
                        "dismiss": 1000,
                    }
                    this.setState({"modal_show": false})
                    this.get_all_dwbm()
                } else {
                    alert_info = {
                        "title": "提示",
                        "content": res.RTN_MSG,
                        "type": "error",
                        "position": "top-right",
                        "dismiss": 1000,
                    }
                }
                PubSub.publish('AlertNotify', alert_info);
            })
        }
    }

    get_all_dwbm = () => {
        PubSub.publish('Loding', true);
        http_call('/jzzwdt/department', 'GET').then(res => {
            this.setState({"tableData": res.DATA})
            PubSub.publish('Loding');
        })
    }

    inquiry_dwbm = (data) => {
        let DATA = {}
        PubSub.publish('Loding', true);
        Object.keys(data).forEach((key)=>{
            DATA[key.replace('search_', '')] = data[key];
        })
        http_call('/jzzwdt/department', 'GET', DATA).then(res => {
            this.setState({"tableData": res.DATA})
            PubSub.publish('Loding');
        })
    }

    render() {
        return (
            <div className='page-inner'>
                <div className="page-header">
                    <h4 className="page-title">{this.state.name}</h4>
                    <ul className="breadcrumbs">
                        <li className="nav-home">
                            <span>
                                <FontAwesomeIcon icon="fa fa-home"/>
                            </span>
                        </li>
                        <li className="separator">
                            <FontAwesomeIcon icon="fa-solid fa-greater-than"/>
                        </li>
                        <li className="nav-item">
                            <span>{this.state.name}</span>
                        </li>
                    </ul>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div style={{"marginLeft": '5px', "marginBottom": '5px'}}>
                                { this.state.func.add ? <button className='btn btn-primary btn-xs'
                                        onClick={e => {
                                            this.add_dwbm(e);
                                        }
                                        }>新增单位部门
                                </button> : null}
                                <TableSearchFields rule={this.state.search_rule} onSearch={(data) => {this.inquiry_dwbm(data)}}/>
                            </div>
                            <DataTable
                                noDataComponent=<h1
                                style={{"textAlign": "center", "marginBottom": '20px'}}>暂无数据</h1>
                            columns={this.state.column}
                            data={this.state.tableData}
                            selectableRows
                            progressPending={this.state.pending}
                            pagination
                            paginationComponentOptions = {{
                                rowsPerPageText:'每页行数:',
                                rangeSeparatorText: '/',
                                selectAllRowsItem: true,
                                selectAllRowsItemText: '全部'
                            }}
                            fixedHeader
                            fixedHeaderScrollHeight={"100vh"}
                            theme=""
                            onSelectedRowsChange={(rows) => {
                            this.setState({"selectRows": rows})
                        }}
                            />
                        </div>
                    </div>
                </div>
                {this.state.modal_show ?
                    <DynamicModal show={this.state.modal_show}
                                  rules={this.state.modal_rules}
                                  title={this.state.modal_title}
                                  submit_title={this.state.modal_submit_title}
                                  close_callback={e => {
                                      this.setState({"modal_show": false})
                                  }}
                                  submit_callback={this.state.modal_submit_callback}
                    />
                    : null
                }
            </div>
        );
    }
}